import ReactDOM from "react-dom/client";
import React from "react";
import { LOCATIONS_ID } from "../utils";
import Locations from "./Locations";

function initLocations() {
  const rootElement = document.getElementById(LOCATIONS_ID);
  const root = ReactDOM.createRoot(rootElement);

  if (!rootElement) return;

  const data = JSON.parse(
    document.getElementById(`${rootElement.dataset.sectionId}-data`).innerText
  );

  root.render(<Locations sectionData={data} />);
}

$(window).on("shopify:section:load", function (e) {
  e.target.querySelector(`#${LOCATIONS_ID}`) && initLocations();
});

document.addEventListener("obp:initialized", () => initLocations());
window?.obp?.locations && initLocations();
